// src/poker/ws/pokerClient.js
import { io } from "socket.io-client";

let socket = null;

export function getPokerSocket() {
  if (socket) return socket;

  const isBrowser = typeof window !== "undefined";
  const onLocal3000 =
    isBrowser &&
    window.location.hostname === "localhost" &&
    window.location.port === "3000";

  // Local dev uses the separate backend port.
  // Everywhere else we connect back to the current site origin,
  // so production does not depend on switching env values by hand.
  const backendOrigin = onLocal3000 ? "http://localhost:3001" : undefined;

  socket = io(backendOrigin, {
    withCredentials: true,
    transports: ["websocket", "polling"],
  });

  return socket;
}

export function pokerPing() {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("PING", (res) => resolve(res));
  });
}

export function pokerCreateRoom(payload = {}) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:ROOM_CREATE", payload, (res) => resolve(res));
  });
}

export function pokerJoinRoom(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:ROOM_JOIN", { code }, (res) => resolve(res));
  });
}

// ✅ leave = "wyjść z gry" (cashout + zniknięcie)
export function pokerLeaveRoom() {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:ROOM_LEAVE", {}, (res) => resolve(res));
  });
}

// ✅ sit out / return
export function pokerSitOut(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:SEAT_SITOUT", { code }, (res) => resolve(res));
  });
}

export function pokerReturnToSeat(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:SEAT_RETURN", { code }, (res) => resolve(res));
  });
}

export function pokerStartGame(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:START_GAME", { code }, (res) => resolve(res));
  });
}

export function pokerDealHand(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:HAND_DEAL", { code }, (res) => resolve(res));
  });
}
export function pokerFlop(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:HAND_FLOP", { code }, (res) => resolve(res));
  });
}
export function pokerTurn(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:HAND_TURN", { code }, (res) => resolve(res));
  });
}
export function pokerRiver(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:HAND_RIVER", { code }, (res) => resolve(res));
  });
}
export function pokerShowdown(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:HAND_SHOWDOWN", { code }, (res) => resolve(res));
  });
}
export function pokerNextHand(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:HAND_NEXT", { code }, (res) => resolve(res));
  });
}
export function pokerAction(code, type, amount) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:ACTION", { code, type, amount }, (res) => resolve(res));
  });
}
export function pokerShowCards(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:SHOW_CARDS", { code }, (res) => resolve(res));
  });
}

export function pokerTourneyPause(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:TOURNEY_PAUSE", { code }, (res) => resolve(res));
  });
}

export function pokerTourneyResume(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:TOURNEY_RESUME", { code }, (res) => resolve(res));
  });
}

export function pokerTourneyNextLevel(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:TOURNEY_NEXT_LEVEL", { code }, (res) => resolve(res));
  });
}

export function pokerTourneyPrevLevel(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:TOURNEY_PREV_LEVEL", { code }, (res) => resolve(res));
  });
}

export function pokerTourneyResetLevel(code) {
  const s = getPokerSocket();
  return new Promise((resolve) => {
    s.emit("POKER:TOURNEY_RESET_LEVEL", { code }, (res) => resolve(res));
  });
}
